import React, { FC } from "react";
import { useSiteMetadata } from "@src/hooks/metadata";

interface Props {
  title?: string;
  description?: string;
  pathname?: string;
  heroImage?: string;
  thirdPartyHeroImage?: boolean;
  children?: JSX.Element[];
}

const SEO: FC<Props> = ({
  title,
  description,
  pathname,
  heroImage,
  children,
  thirdPartyHeroImage = false,
}) => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    image,
    siteUrl,
  } = useSiteMetadata();
  const imageSep = heroImage?.startsWith("/") ? "" : "/";
  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${thirdPartyHeroImage === false ? siteUrl : ""}${
      thirdPartyHeroImage === false ? imageSep : ""
    }${heroImage || image}`,
    url: `${siteUrl}${pathname || ""}${!pathname?.endsWith("/") ? "/" : ""}`,
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={seo.image} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:site_name" content="Pangea"></meta>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <link rel="canonical" href={seo.url} />

      <script
        id="vtag-ai-js"
        async
        src="https://r2.leadsy.ai/tag.js"
        data-pid="17MNDH6Xoil66kL7j"
        data-version="062024"
        type="text/plain"
        data-cookieconsent="marketing"
      ></script>

      {children}
    </>
  );
};

export default SEO;
